import request from './request';
import { AxiosQueueManager } from 'axios-queue-js';

const axiosQueueClient = new AxiosQueueManager({ queueSize: 1, client: request });

export default axiosQueueClient;
